import { ButtonIcon } from '@statsbomb/kitbag-components';

export const UuidButton = () => (
  <div data-testid="formatted-uuid-info-button">
    <ButtonIcon title="Information" size="small" variant="ghost" icon="Info" disabled />
  </div>
);
